import React, { useContext, useEffect, useRef, useState } from "react";
import { Sorting } from "../../../../../components/Lists/Sorting";
import "./PartRequestList.css";
import { PartRequestManagementContext } from "../../../context/PartRequestManagementContext";
import Skeleton from "react-loading-skeleton";
import Item from "../../../../../components/Lists/Item";
import { ResultsNotFound } from "../../../../../components/ResultsNotFound/ResultsNotFound";
import { CONTEXT_TYPES } from "../../../../../globals/globals";
import CheckboxField from "../../../../../components/Checkbox/CheckboxField";
import Checkbox from "../../../../../components/Checkbox/Checkbox";
import { Tooltip } from "@mui/material";
import { DialogContext } from "../../../../../contexts/DialogContext";
import { GlobalPartStock } from "../Modals/GlobalPartStock";
import { GenericPartRequestModal } from "../../../../StoresModule/Components/PartRequest/PartRequestModals/GenericPartRequestModal";
import { useNavigate } from "react-router-dom";
import { clearActiveTab } from "../../../../../redux/features/TabsManager/tabSlice";
import { useDispatch } from "react-redux";
import { SortingHeader } from "../../../../../components/Sorting/SortingHeader";

const icons = {
  success: "icon-success",
  warning: "icon-warning",
  error: "icon-error",
};
const PartImage = ({ item }) => {
  const { partsToOrder, setPartsToOrder, dataList, setDataList } = useContext(
    PartRequestManagementContext
  );
  const { openDialog, closeDialog } = useContext(DialogContext);
  const changeValue = (item, key, event) => {
    const hasSelectedParts = partsToOrder?.length > 0;

    const isDifferentCompany =
      hasSelectedParts && item.company_name != partsToOrder[0].company_name;

    if (isDifferentCompany) {
      openDialog({
        component: GenericPartRequestModal,
        props: {
          title: "Warning",
          description: `You have selected part requests from <strong>${partsToOrder[0].company_name}</strong>.<br/>Please select part requests from the same company only.`,
          close: closeDialog,
          okAction: () => closeDialog,
          displayButton: false,
          displayCloseButton: false,
        },
      });
      return;
    }
    const isChecked = event;

    const updatedItem = { ...item, [key]: isChecked };

    setPartsToOrder((prev) => {
      if (isChecked) {
        const exists = prev.find(
          (p) => p.id === item.id && p.part_id === item.part_id
        );
        if (exists) {
          return prev.map((p) =>
            p.id === item.id && p.part_id === item.part_id ? updatedItem : p
          );
        } else {
          return [...prev, updatedItem];
        }
      } else {
        return prev.filter(
          (p) => p.id !== item.id && p.part_id !== item.part_id
        );
      }
    });

    setDataList((prev) =>
      prev.map((p) =>
        p.id === item.id && p.part_id === item.part_id
          ? { ...p, [key]: isChecked }
          : p
      )
    );
  };

  return (
    <div className="image-container-checkbox">
      <Checkbox
        outlined
        checked={item.toOrder}
        onChange={(e) => changeValue(item, "toOrder", e)}
      />
      <div className={`image-container ${item.status}`}>
        <i className={icons[item.status]}></i>
      </div>
    </div>
  );
};
export const PartRequestList = () => {
  const {
    loadingParts,
    setLoadingPartsReq,
    dataList,
    setSortingOrder,
    requestNextPage,
    page,
  } = useContext(PartRequestManagementContext);
  const { openDialog, closeDialog } = useContext(DialogContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  //Tooltips
  const propertyRefs = useRef({});
  const [tooltips, setTooltips] = useState({});
  const listRef = useRef(null);
  const getSortingOrder = (order) => {
    setSortingOrder(order);
  };
  const handleScroll = (event) => {
    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
    if (scrollHeight - (scrollTop + 3) <= clientHeight) {
      if (!setLoadingPartsReq) requestNextPage();
    }
  };
  useEffect(() => {
    const newTooltips = {};
    Object.entries(propertyRefs.current).forEach(([key, el]) => {
      if (el) {
        newTooltips[key] = el.scrollWidth > el.clientWidth;
      }
    });
    setTooltips(newTooltips);
  }, []);

  const saveSuccess = () => {
    console.warn("saveSuccess");
  };

  const openModal = (item, label) => {
    if (!item || !label) {
      console.warn("item o label no definidos");
      return;
    }
    const idOrders = item.order_ids ? item.order_ids.split(",") : [];
    const idTransfers = item.prn_transfers_id
      ? item.prn_transfers_id.split(",")
      : [];
    switch (label) {
      case "other_locations_avl":
        openDialog({
          component: GlobalPartStock,
          props: {
            part: item,
            close: closeDialog,
            okAction: () => saveSuccess(),
          },
        });
        break;
      case "pending_quotes":
        dispatch(clearActiveTab());
        navigate("/secure/supplychain/quote-tracking");
        break;
      case "pending_order":
        if (idOrders.length === 0) {
          return;
        }
        dispatch(clearActiveTab());
        navigate("/secure/supplychain/orders-management", {
          state: { dataFromPrns: idOrders, companySource: item.company_id },
        });
        break;
      case "pending_transfer":
        if (idTransfers.length === 0) {
          return;
        }
        dispatch(clearActiveTab());
        navigate("/secure/store/part-request-management", {
          state: { dataFromPrns: idTransfers },
        });
        break;
      default:
        console.warn("Etiqueta no reconocida:", label);
        break;
    }
  };
  return (
    <>
      <div className="sorting-header">
        <div className="sorting-free-slot"> </div>
         <SortingHeader></SortingHeader>
      </div>
      <div className="supply-chain-list" ref={listRef} onScroll={handleScroll}>
        {loadingParts && page === 0 ? (
          // Mostrar esqueletos mientras carga
          Array.from({ length: 7 }).map((_, idx) => (
            <div key={idx} className="item-container-skeleton">
              <Skeleton
                style={{ borderRadius: "10px" }}
                height="1.68rem"
                width={40}
              />
              <div className="item-skeleton-content">
                <Skeleton height={20} width="80%" />
              </div>
              <Skeleton height={30} width="7rem" />
            </div>
          ))
        ) : dataList.length === 0 ? (
          <ResultsNotFound />
        ) : (
          dataList.map((item, idx) => (
            <React.Fragment key={`${item.id}-${idx}`}>
              <div className="item-prn-management-container">
                <PartImage item={item} />
                {[
                  "id",
                  "part_number",
                  "quantity",
                  "issued_quantity_posted",
                  "remaining_quantity",
                  "available_quantity",
                  "pending_order",
                  "pending_transfer",
                  "other_locations_avl",
                  "pending_quotes",
                  "pr_location_code",
                  "pr_site_name",
                  "company_name",
                  "date_request_required",
                ].map((label) => (
                  <div
                    className={`property ${
                      label === "quantity" ||
                      label === "issued_quantity_posted" ||
                      label === "remaining_quantity" ||
                      label === "available_quantity" ||
                      label === "pending_order" ||
                      label == "pending_quotes" ||
                      label === "pending_transfer" ||
                      label === "other_locations_avl"
                        ? "centerItem"
                        : ""
                    }`}
                    key={label}
                  >
                    {label == "task_card_number" && (
                      <i className="icon-task_icon_partRequest"></i>
                    )}
                    <Tooltip
                      title={tooltips[`${item.id}-${label}`] ? item[label] : ""}
                      arrow
                    >
                      {label == "available_quantity" ||
                      label == "pending_order" ||
                      label == "pending_quotes" ||
                      label == "pending_transfer" ||
                      label == "other_locations_avl" ? (
                        <p
                          onClick={() => {
                            openModal(item, label);
                          }}
                          className="bold-font"
                          ref={(el) => {
                            if (el) {
                              propertyRefs.current[`${item.id}-${label}`] = el;
                            }
                          }}
                        >
                          {item[label] + " " + item["uom_abrevation"]}
                        </p>
                      ) : label == "quantity" ||
                        label == "issued_quantity_posted" ||
                        label == "remaining_quantity" ? (
                        <p
                          onClick={() => {
                            openModal(item, label);
                          }}
                          className="bold-font-black"
                          ref={(el) => {
                            if (el) {
                              propertyRefs.current[`${item.id}-${label}`] = el;
                            }
                          }}
                        >
                          {item[label] + " " + item["uom_abrevation"]}
                        </p>
                      ) : label == "date_request_required" ? (
                        <p
                          className="bold-font-date"
                          ref={(el) => {
                            if (el) {
                              propertyRefs.current[`${item.id}-${label}`] = el;
                            }
                          }}
                        >
                          {item[label]}
                        </p>
                      ) : (
                        <p
                          className="light-font"
                          ref={(el) => {
                            if (el) {
                              propertyRefs.current[`${item.id}-${label}`] = el;
                            }
                          }}
                        >
                          {item[label]}
                        </p>
                      )}
                    </Tooltip>
                  </div>
                ))}
              </div>
            </React.Fragment>
          ))
        )}
      </div>
    </>
  );
};
